// extracted by mini-css-extract-plugin
export var actions = "_3y-0";
export var actionsContainer = "_3y-6";
export var border = "_3y-1";
export var childFullHeight = "_3y-d";
export var collapse = "_3y-2";
export var content = "_3y-8";
export var contentChild = "_3y-c";
export var fullscreen = "_3y-a";
export var headerContainer = "_3y-3";
export var headerRow = "_3y-5";
export var hidePadding = "_3y-9";
export var noScrollX = "_3y-e";
export var noScrollY = "_3y-f";
export var optOutTopPadding = "_3y-b";
export var pagePadding = "_3y-7";
export var profile = "_3y-g";
export var profileContainer = "_3y-h";
export var profileImage = "_3y-i";
export var profileMain = "_3y-j";
export var profileSubtitle = "_3y-l";
export var profileTitle = "_3y-k";
export var tabsWrapper = "_3y-4";
export var title = "_3y-m";